import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "publish-drawer__content" }
const _hoisted_2 = { class: "publish-drawer__tpl-card" }
const _hoisted_3 = { class: "publish-drawer__tpl-value" }
const _hoisted_4 = { class: "publish-drawer__tpl-value" }

import {
  useBaseAsync,
  type HpsfirProFormItem,
} from 'hpsfir-managebase-ui';

import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'publish',
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;

const setFormRef = ref<any>();

const visible = ref(false);
const weapp = ref({} as any);
const tpl = ref<any>();

const items = ref<HpsfirProFormItem[]>([]);

const initValues = ref({} as any);

watch(visible, () => {
  if (!visible.value) {
    emit('close');
  }
});

const loading = ref(false);

const formData = ref({} as any);

const handleFormChange = useBaseAsync((data: any) => {
  formData.value = { ...data };
});

const handlePublish = useBaseAsync(async() => {
  try {
    loading.value = true;
    await useApi().weappApi.publishWeappweapp({
      appid: weapp.value.appid,
      ext: formData.value,
    });
    ElMessage.success('提交发布审核成功');
    visible.value = false;
  } finally {
    loading.value = false;
  }
});

__expose({
  show: async(_weapp: any, _tpl: any) => {
    let tenant: any;
    try {
      const res = await useApi().tenantApi.getTenantComInfotenant();
      if (res?.data?.data) {
        tenant = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }

    weapp.value = _weapp;
    tpl.value = _tpl;
    initValues.value = {};
    formData.value = {};
    items.value = _tpl?.extjsFormItems?.map((item: any) => {
      if (_weapp.ext?.[item.name] !== undefined) {
        initValues.value[item.name] = _weapp.ext?.[item.name];
      } else if (item.tenantKey && tenant?.[item.tenantKey]) {
        initValues.value[item.name] = tenant?.[item.tenantKey];
      }
      if (item.required) {
        item.rule = [{ required: true }];
      }
      if (item.type === 'image') {
        return {
          ...item,
          action: useApi().uploadImageUrl,
          multiple: false,
          onSuccess(data: any) {
            setFormRef.value?.setOneFormState(item.name, data.data[0]);
          },
        };
      }
      return item;
    }) || [];
    visible.value = true;
  },
});

return (_ctx: any,_cache: any) => {
  const _component_HpsfirProForm = _resolveComponent("HpsfirProForm")!
  const _component_HpsfirButton = _resolveComponent("HpsfirButton")!
  const _component_HpsfirProDrawer = _resolveComponent("HpsfirProDrawer")!

  return (_openBlock(), _createBlock(_component_HpsfirProDrawer, {
    open: visible.value,
    "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    title: "配置发布",
    width: "70vw",
    "max-width": "980px",
    "content-class": "publish-drawer",
    "body-class": "publish-drawer__body",
    "footer-class": "publish-drawer__footer"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_HpsfirButton, {
        variant: "outline",
        onClick: _cache[0] || (_cache[0] = () => visible.value = false)
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createTextVNode("取消", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_HpsfirButton, {
        onClick: _unref(handlePublish),
        disabled: loading.value
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
          _createTextVNode("发布", -1)
        ]))]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "publish-drawer__tpl-label" }, "模板名称", -1)),
            _createElementVNode("div", _hoisted_3, _toDisplayString(tpl.value?.name || '未知'), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "publish-drawer__tpl-label" }, "模板版本", -1)),
            _createElementVNode("div", _hoisted_4, _toDisplayString(tpl.value?.currentVersion || '未知'), 1)
          ])
        ]),
        (visible.value && items.value.length)
          ? (_openBlock(), _createBlock(_component_HpsfirProForm, {
              key: 0,
              ref_key: "setFormRef",
              ref: setFormRef,
              "init-form-value": initValues.value,
              title: "配置模板",
              items: items.value,
              "hide-cancel": true,
              "hide-ok": true,
              onChange: _unref(handleFormChange)
            }, null, 8, ["init-form-value", "items", "onChange"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})